import { Action } from '@ngrx/store';
import { IUser } from '@interfaces/IUser';
import { IAuthStateErrors } from './auth.state';

export enum EAuthActions {
  ResetPassword = '[Auth] Reset Password',
  ResetPasswordRequest = '[Auth] Reset Password Request',
  ResetPasswordRequestSuccess = '[Auth] Reset Password Request Success',

  GetTokenValidity = '[Auth] Get Token Validity',
  GetTokenValiditySuccess = '[Auth] Get Token Validity Success',

  Login = '[Auth] Login',
  LoginSuccess = '[Auth] Login Success',

  Logout = '[Auth] Logout',
  LogoutSuccess = '[Auth] Logout Success',

  RequestFailure = '[Auth] Request Failure',
  Refresh = '[Auth] Refresh',

  ResetNotifications = '[Auth] Reset Notifications',
  UpdateStateMessage = '[Auth] UpdateStateMessage',
  UpdateAuthUser = '[Auth] Update Auth User',
}

export class Login implements Action {
  public readonly type = EAuthActions.Login;

  constructor(public userData: IUser) {}
}

export class LoginSuccess implements Action {
  public readonly type = EAuthActions.LoginSuccess;

  constructor(public user: IUser) {}
}

export class Logout implements Action {
  public readonly type = EAuthActions.Logout;
}

export class LogoutSuccess implements Action {
  public readonly type = EAuthActions.LogoutSuccess;
}

export class Refresh implements Action {
  public readonly type = EAuthActions.Refresh;
}

export class UpdateAuthUser implements Action {
  public readonly type = EAuthActions.UpdateAuthUser;

  constructor(public user: IUser) {}
}

export class RequestFailure implements Action {
  public readonly type = EAuthActions.RequestFailure;

  constructor(public errors: IAuthStateErrors) {}
}

export class ResetNotifications implements Action {
  public readonly type = EAuthActions.ResetNotifications;
}

export class UpdateStateMessage implements Action {
  public readonly type = EAuthActions.UpdateStateMessage;

  constructor(public message: string) {}
}

export class GetTokenValiditySuccess implements Action {
  public readonly type = EAuthActions.GetTokenValiditySuccess;
}

export class GetTokenValidity implements Action {
  public readonly type = EAuthActions.GetTokenValidity;

  constructor(public token: string) {}
}

export class ResetPassword implements Action {
  public readonly type = EAuthActions.ResetPassword;

  constructor(
    public passwordData: {
      password: string;
      confirm_password: string;
      confirmed_token: string;
    }
  ) {}
}

export class ResetPasswordRequest implements Action {
  public readonly type = EAuthActions.ResetPasswordRequest;

  constructor(public email: { email: string }) {}
}

export class ResetPasswordRequestSuccess implements Action {
  public readonly type = EAuthActions.ResetPasswordRequestSuccess;

  constructor(public message: string) {}
}

export type AuthActions =
  | Login
  | RequestFailure
  | LoginSuccess
  | Refresh
  | Logout
  | LogoutSuccess
  | ResetNotifications
  | UpdateStateMessage
  | UpdateAuthUser
  | ResetPasswordRequestSuccess
  | GetTokenValiditySuccess
  | GetTokenValidity;
